import { Button } from "@/components/ui/button";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { useConfirm } from "@/context/confirm-context";
import { useDeleteWorkspaceInvite } from "@/queries/workspace-invites";
import { WorkspaceInvite } from "@/types/workspace-invite";
import { XIcon } from "lucide-react";

interface DeleteInviteProps {
  invite: WorkspaceInvite;
}

const DeleteInvite = ({ invite }: DeleteInviteProps) => {
  const deleteWorkspaceInvite = useDeleteWorkspaceInvite();
  const { confirm } = useConfirm();

  const handleClick = async () => {
    const isConfirmed = await confirm({
      message:
        "Are you sure you want to delete this invite? This action cannot be undone.",
    });
    if (isConfirmed) deleteWorkspaceInvite.mutate(invite.id);
  };

  return (
    <BasicTooltip content="Cancel invite">
      <Button variant="ghost" size="tinyIcon" onClick={handleClick}>
        <XIcon className="h-4 w-4" />
      </Button>
    </BasicTooltip>
  );
};

export default DeleteInvite;
